import { Component } from 'react';
import BenefitOption from './benefitoption.js';
import { getAdditionalForBenefit, receivingBenefit } from './shared.js';

export default class MembershipBenefitPanel extends Component {
  getAdditionalString() {
    const num = getAdditionalForBenefit(
      this.props.amount,
      this.props.frequency
    );
    return Math.ceil(num * 100) / 100;
  }

  getAdditionalFrequency() {
    if (this.props.frequency === 'monthly') {
      return 'per month';
    }

    return '';
  }

  render() {
    let className = '';
    let message;
    let shouldDisplayOption = false;
    if (!this.props.benefitDesired) {
      shouldDisplayOption = true;
      message = <span>You have chosen not to get a tote bag.</span>;
    } else if (this.props.amount == '') {
      message = '';
    } else if (receivingBenefit(this.props.amount, this.props.frequency)) {
      shouldDisplayOption = true;
      className = 'highlighted';
      message = <span>You get a tote bag!</span>;
    } else {
      message = (
        <span className="highlighted">
          Give ${this.getAdditionalString()} more{' '}
          {this.getAdditionalFrequency()} to get a tote bag.
        </span>
      );
    }

    return (
      <div className={`benefit-panel ${className}`}>
        <div className="tote-language">
          {message}{' '}
          {shouldDisplayOption && (
            <BenefitOption
              onToggle={this.props.toggleBenefitDesired}
              desired={this.props.benefitDesired}
            />
          )}
        </div>
      </div>
    );
  }
}
